import React, { createContext, useContext, useMemo, useState } from 'react';

const CalendarTimelineContext = createContext(null);

export const CalendarTimelineProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarViewType, setCalendarViewType] = useState('MONTH');
  const [timelineViewType, setTimelineViewType] = useState('WEEK');

  const value = useMemo(() => ({
    selectedDate,
    setSelectedDate,
    calendarViewType,
    setCalendarViewType,
    timelineViewType,
    setTimelineViewType,
  }), [selectedDate, calendarViewType, timelineViewType]);

  return (
    <CalendarTimelineContext.Provider value={value}>
      {children}
    </CalendarTimelineContext.Provider>
  );
};

export const useCalendarTimeline = () => {
  const context = useContext(CalendarTimelineContext);
  if (!context) {
    throw new Error('useCalendarTimeline must be used within CalendarTimelineProvider');
  }
  return context;
};

export default CalendarTimelineContext;
